import React from 'react'
import img2025 from '../components/images/meesho.jpg'

const events = () => {
    return (

        <>
            <div className='container'>
                <div className="row  m-2">
                    <img src={img2025} alt='meesho' />
                </div>
                <div className="row m-2">
                    <div className="col-sm ">

                        <h2 className='p-2'>Drive Your Meesho Growth with E Seller Support’s Expertise
                        </h2>
                        <p>As a dedicated Meesho partner, E Seller Support is uniquely positioned to provide you with unmatched expertise and support in managing your Meesho store. Our wide-ranging services, including account setup, product listing optimization, and inventory management, are designed to help your business reach its full potential on Meesho, one of India’s leading social commerce platforms. With our specialized knowledge and Meesho-backed solutions, we simplify the complexities of selling on Meesho, enabling you to boost sales and enhance visibility effortlessly. Trust E Seller Support to drive your success and help you thrive in the dynamic e-commerce landscape. </p>
                    </div>
                    <div className="col-sm ">
                        {/* <img src={img201} alt='Queryimg' /> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default events
